import script from "./site-info.vue?vue&type=script&lang=ts&setup=true"
export * from "./site-info.vue?vue&type=script&lang=ts&setup=true"

import "./site-info.vue?vue&type=style&index=0&id=1c7b0d85&lang=scss&scoped=true"

import exportComponent from "D:\\Projects\\WebStorm\\tianshu-platform\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1c7b0d85"]])

export default __exports__